import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// create relative comparitive analysis
// export async function addRelativeCompAnalysis(payload) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/relative_analysis/`,{
//             method:'POST',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(payload)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to create Relative comparitive analysis");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while creating add relative comparitive analysis", error?.data || error.message)
//         throw error;
//     }
// }

// Helper function
async function attemptAddRelativeCompAnalysis(payload, token) {
    const response = await fetch(`${API_URL}/relative_analysis/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to create Relative Comparative Analysis");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function addRelativeCompAnalysis(payload) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try {
        return await attemptAddRelativeCompAnalysis(payload, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptAddRelativeCompAnalysis(payload, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }

        console.log("Error while creating Relative Comparative Analysis:", error?.data || error.message);
        throw error;
    }
}

// get relative comparitive analysis
// export async function getRelativeCompAnalysis(orderId) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/relative_analysis/?order_id=${orderId}`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to get Relative comparitive analysis");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while creating getting relative comparitive analysis", error?.data || error.message)
//         throw error;
//     }
// }

// Helper function
async function attemptGetRelativeCompAnalysis(orderId, token) {
    const response = await fetch(`${API_URL}/relative_analysis/?order_id=${orderId}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to get Relative Comparative Analysis");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function getRelativeCompAnalysis(orderId) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try {
        return await attemptGetRelativeCompAnalysis(orderId, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed to be globally defined
                return await attemptGetRelativeCompAnalysis(orderId, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }

        console.error("Error while getting Relative Comparative Analysis:", error?.data || error.message);
        throw error;
    }
}

// update relative analysis
// export async function updateRelativeAnalysis({payload,id}) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))
//         console.log("on api", payload,id)
//         const response = await fetch(`${API_URL}/relative_analysis/${id}/`,{
//             method:'PATCH',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(payload)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to get Relative comparitive analysis");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while updating getting relative comparitive analysis", error?.data || error.message)
//         throw error;
//     }
// }

// Helper function
async function attemptUpdateRelativeAnalysis(id, payload, token) {
    const response = await fetch(`${API_URL}/relative_analysis/${id}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to update Relative Comparative Analysis");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function updateRelativeAnalysis({ payload, id }) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try {
        return await attemptUpdateRelativeAnalysis(id, payload, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed to exist globally
                return await attemptUpdateRelativeAnalysis(id, payload, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }

        console.error("Error while updating Relative Comparative Analysis:", error?.data || error.message);
        throw error;
    }
}
